import React from 'react';
import { Link } from 'react-router-dom';
import NavbarLogo from '../shared/NavbarLogo';
import logoImageOrange from '../../../../../assets/images/branding/gg_navbar_brand_orange.png';
import logoImageGrey from '../../../../../assets/images/branding/gg_navbar_brand_grey.png';
import logoImageWhite from '../../../../../assets/images/branding/gg_navbar_brand_white.png';

interface GuestNavbarProps {
  scrolling: boolean;
  useWhiteText: boolean;
  onLogoClick: () => void;
}

const GuestNavbar: React.FC<GuestNavbarProps> = ({
  scrolling,
  useWhiteText,
  onLogoClick
}) => {
  return (
    <div className={scrolling ? 'navbar scroll' : 'navbar'}>
      {/* Logo */}
      <NavbarLogo
        scrolling={scrolling}
        useWhiteText={useWhiteText}
        logoImageOrange={logoImageOrange}
        logoImageWhite={logoImageWhite}
        logoImageGrey={logoImageGrey}
        onLogoClick={onLogoClick}
      />

      {/* Navigation Links */}
      <div className="navbar-list">
        <Link className={useWhiteText ? 'navbar-list-links whiteText' : "navbar-list-links"} to="/categories">
          Categories
        </Link>
        <Link className={useWhiteText ? 'navbar-list-links whiteText' : "navbar-list-links"} to="/become-a-freelancer">
          Become a Freelancer
        </Link>
        <Link className={useWhiteText ? 'navbar-list-links whiteText' : "navbar-list-links"} to="/about">
          About Us
        </Link>
        <Link className={useWhiteText ? 'navbar-list-links whiteText' : "navbar-list-links"} to="/FAQs">
          FAQs
        </Link>
      </div>

      {/* Login Button */}
      <div className="navbar-login-btn-cover">
        <Link className="navbar-login-btn" to="/login">
          Login
        </Link>
      </div>
    </div>
  );
};

export default GuestNavbar;
